import Loader from 'components/Common/Loader';
import NoData from 'components/Common/NoData';
import React, {FC} from 'react';

import {TeaserArticle} from 'utils/types';

import './styles.scss';

interface Props {
  loading?: boolean;
  articles?: TeaserArticle[];
}

const WidgetTeaser: FC<Props> = ({loading, articles}: Props) => {
  /* eslint-disable react/jsx-no-target-blank */

  return (
    <section className="WidgetTeaser">
      <h3 className="WidgetTeaser__header">ΔΙΑΒΑΣΤΕ ΑΚΟΜΑ</h3>{' '}
      {/* TODO: dynamic title from feed group name */}
      {(!articles || !articles.length) && loading && <Loader />}
      {!articles || !articles.length ? (
        <NoData />
      ) : (
        articles.map(
          ({eceId, url, title, tag, image, publishedDate, impressionUrl}, i) =>
            /* TODO: fallback image */ image && (
              <article
                className={`WidgetTeaser__article ${
                  i === 0 ? 'WidgetTeaser__article--big' : 'WidgetTeaser__article--small'
                }`}
                key={eceId}
              >
                <figure className="WidgetTeaser__image">
                  <a href={url} target="_blank">
                    <img
                      src={
                        i === 0
                          ? image.url.replace(/\/(w?)620(?=\/)/g, '/$1380')
                          : image.url.replace(/\/(w?)620(?=\/)/g, '/$1140')
                      }
                      alt={image.caption}
                    />
                  </a>
                </figure>
                <div className="WidgetTeaser__meta">
                  {tag && (
                    <a className="WidgetTeaser__tag" href={tag.url} target="_blank">
                      {tag.displayName}
                    </a>
                  )}
                  <a className="WidgetTeaser__title" href={url} target="_blank">
                    {title}
                  </a>
                  <span className="WidgetTeaser__date">
                    <span>{publishedDate.toLocaleDateString('de-DE')}</span>
                    <span>
                      {publishedDate.toLocaleTimeString('el-GR', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      })}
                    </span>
                  </span>
                </div>
                {impressionUrl && (
                  <img
                    src={impressionUrl}
                    alt="impression"
                    style={{display: 'none', position: 'absolute'}}
                  />
                )}
              </article>
            )
        )
      )}
    </section>
  );
};

export default React.memo(WidgetTeaser);
